// extracted by mini-css-extract-plugin
export default {"reasonsContainer":"TypeOfTraining_reasonsContainer__PhFk1","header":"TypeOfTraining_header__wCexh","noReasons":"TypeOfTraining_noReasons__V62s2"};